import ConstrainInterface from "./Constrain.interface";

import { pluralize } from "utils/text";

abstract class Constrain implements ConstrainInterface {
  protected value: number;
  protected multiplier: number;
  protected errorMessage?: string;

  constructor(value: number, multiplier?: number, errorMessage?: string) {
    this.value = value;
    this.multiplier = multiplier ?? 1;
    this.errorMessage = errorMessage;
  }

  getValue(): number {
    return this.value;
  }

  getErrorMessage(productsCount: number): string {
    if (productsCount === this.getValue()) {
      return `You've already bought ${pluralize(
        productsCount,
        "item",
      )} for the entire collection or some of the transactions are still pending. If you don't have two confirmed transactions, wait 3 minutes to buy another one item.`;
    }

    return `You've already bought ${pluralize(
      productsCount,
      "item",
    )} from this store, you can buy only ${
      this.getValue() - productsCount < 0 ? 0 : this.getValue() - productsCount
    } more. If the transaction is still pending, please wait 3 minutes to buy up to ${this.getValue()} items.`;
  }

  isValid(value: number, currentAmount: number): boolean {
    return value < this.value && this.value >= value + currentAmount;
  }

  abstract getName(): string;

  abstract getMaxValue(): number;
}

export default Constrain;
